const _ = require('lodash');
const atmInternalCampaignMapper = require('../analytics/atm-mapper-internal-campaign');

module.exports = function (bannerService, $location, $sce, $compile, breakpointsService, atm) {
    return {
        restrict: 'E',
        scope: {
            designType: '@',
            stockcode: '=?'
        },
        link(scope, element) {

            scope.breakpointsService = breakpointsService;
            //the below is set as a standard for dynamic content team to use the service to get browser window widths
            // the team uses as: ng-if="breakpoints.isInMediumFormat || breakpoints.isInLargeFormat" or ng-if="breakpoints.isInSmallFormat"
            scope.breakpoints = breakpointsService;

            scope.bannerType = {
                image: 'Image',
                html: 'Html'
            };

            const addClickTracking = (banner, $banner, index) => {
                const place = banner.DesignType.toLowerCase();
                const campaignName = banner.CampaignName;
                const position = index + 1;

                $banner.on('click', 'a', { type: 'banner', campaignName, place, position }, scope.trackClick);
            };

            bannerService.getBanners({ location: $location.$$url, stockcode: scope.stockcode }).then(function (banners) {
                scope.banners = _.filter(banners.Items, { DesignType: scope.designType });

                _.map(scope.banners, (banner, index) => {

                    const contentHtml = banner.Html;
                    if (contentHtml) {
                        const html = '<div>' + contentHtml.replace(/<img\s/g, '<img loading="lazy" ') + '</div>';
                        const $banner = $compile(html)(scope);
                        element.append($banner);

                        addClickTracking(banner, $banner, index);
                    }
                });
            });

            scope.trustAsHtml = function (html) {
                return $sce.trustAsHtml(html);
            };

            scope.trackClick = (event) => {
                atm.push({
                        type: event.data.type,
                        campaignName: event.data.campaignName,
                        place: event.data.place,
                        position: event.data.position
                    },
                    atmInternalCampaignMapper);
            };

            scope.$on('$destroy', function () {
                bannerService.clearBanners();
            });
        },
        template: require('./banners-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/banners/banners-directive.js
 **/